// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-drawer__content[data-v-5fdbfec7] {\n  padding: 0 40px;\n}\n.selWidth[data-v-5fdbfec7] {\n  width: 500px;\n}", ""]);
// Exports
module.exports = exports;
